import { render, staticRenderFns } from "./Wizard-4.vue?vue&type=template&id=39ab1198&"
import script from "./Wizard-4.vue?vue&type=script&lang=js&"
export * from "./Wizard-4.vue?vue&type=script&lang=js&"
import style0 from "./Wizard-4.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports